interface MentorSection {
  header: string;
  imageUrl: string;
  title: string;
  description: string;
  buttonText: string;
  tooltip: string;
}

export const sectionSharedCollectibles: MentorSection = {
  header: "Shared Collectibles",
  imageUrl:
    "https://mentoro-assets.s3.us-west-1.amazonaws.com/portals/public/participant/mentor/mentorCollectibles.svg",
  title: "Quick Access to Collectibles",
  description:
    "Once you meet with your mentor, you'll have access to your shared personal library of resources they have selected from their personal collection for you to achieve your focus.",
  buttonText: "View My Mentor’s Collectibles",
  tooltip: "Resources chosen by mentor to support your goals.",
};
